'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('alignSelf', 'alignSelf');


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/align-self.js
// module id = 4353
// module chunks = 168707334958949